var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion"},[_c('h4',{on:{"click":_vm.toggleState}},[_vm._v("\n\t\t"+_vm._s(_vm.heading)+"\n\t\t"),_vm._t("heading"),(!_vm.stayOpen)?_c('i',{staticClass:"fa",class:{
			'fa-chevron-down': _vm.isOpen,
			'fa-chevron-right': !_vm.isOpen
		}}):_vm._e()],2),(_vm.isOpen)?_c('div',{staticClass:"accordion-container"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }